"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListItemText = exports.StyledListItemButton = exports.StyledList = exports.StyledDivider = exports.StyledDialog = void 0;
var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const StyledDialog = exports.StyledDialog = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    [`.${_components.dialogClasses.dialogGrid}`]: {
      width: 472
    }
  }
}));
const StyledList = exports.StyledList = (0, _mui.styled)(_mui.List)({
  padding: 0
});
const StyledListItemText = exports.StyledListItemText = (0, _mui.styled)(_mui.ListItemText)(({
  theme
}) => ({
  color: theme.palette.grey[900],
  letterSpacing: '-0.2px',
  ...theme.typography.button,
  textTransform: 'none'
}));
const StyledListItemButton = exports.StyledListItemButton = (0, _mui.styled)(_mui.ListItemButton)(({
  theme
}) => ({
  height: '70px',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2)
}));
const StyledDivider = exports.StyledDivider = (0, _mui.styled)(_mui.Divider, {
  shouldForwardProp: propName => (0, _isPropValid.default)(propName)
})(({
  isItemHovered,
  theme
}) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  height: '0px',
  ...(isItemHovered ? null : {
    marginLeft: '10px',
    marginRight: '10px'
  })
}));